import React, { Component } from "react";
import { Button, Form, Icon,Grid, Table, Card } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationManager} from 'react-notifications';
import { mail, password } from '../../herramientas/Forms';
import { Auth } from '../../Auth/Auth';
let send= false;
class RecuperarPassword extends Component {
  constructor(props) {
    super(props);
              this.state  = {
                             newPassword : '',
                             newPasswordC: '',
                             correo: '',
                             send: false,
                             modo2fa: false,
                             username2fa: '',
                             token2fa: '',
                             showQr: false,
                             qrImage: {},
              };

              this.passwordObj= {
               "token"  :  this.props.token,
               "newPassword"    :  ""
              };

                         
  
  }
  componentDidMount=()=>{
  }


  crud_putPassword() { console.log(this.passwordObj);
    this.getfuntion("put", this.passwordObj, "",  "usuarios/auto_recuperar_password", "contrana");
  }
  crud_putPassword2fa() {
    const obj = { token: this.state.token2fa, newPassword: this.state.newPassword };
    this.getfuntion("put", obj, "", "usuarios/recuperar_password_2fa?username=" + this.state.username2fa, "contrana");
  }

  enviarCorreo() { 
    if(!send){
      send= true;
      this.setState({send: true});
      this.getfuntion("get", this.passwordObj, "",  "mail/enviar_codigo_de_recuperacion?correo="+this.state.correo, "correo");
    }
  }    
        
  getfuntion = (metodo = "get", obj = [], id = "", catalogo = "personas/plataforma/"+this.state.idPlataforma.value , stateVar = "personas" ) => {
    return Crud_Catalogos(metodo !== "post" && catalogo.includes("personas")? "personas":catalogo , "tracking", metodo, id, obj, "", stateVar  ).then((returnVal) => {
      switch (metodo) {
        case "get":
          {
            if (stateVar === "correo") {
              send= false;
              this.setState({send: false});
              NotificationManager.info(returnVal, "notificación");    
            }
          }
          break;
        case "put":
          {
            if (stateVar === "contrana") {
              if(returnVal.status===200){                
                NotificationManager.success(returnVal.message, "Modificación");
                if(this.state.modo2fa){
                  this.setState({ showQr: true, qrImage: returnVal });
                }else{
                  window.location.href="/login";
                }
              }else{
                this.setState({token2fa:""});
                this.passwordObj.token="";
                NotificationManager.error(returnVal.message, "Modificación");
              }
            }
          }
          break;
        default:
          break;
      }
    }).catch(err => {
      console.log(err);
      if (stateVar === "correo") {
        send= false;
        this.setState({send: false});
        NotificationManager.error(err?.response?.data, "Error ("+err?.response?.status+")");    
      }
    });
  }


  changeNewPassword = (event) => {
    this.setState({newPassword:event.target.value});
    this.passwordObj.newPassword=event.target.value;
  }


  render() {
    return (
      <div>
        <h2>{this.props.token? "Recuperar contraseña": this.state.modo2fa? "Recuperar contraseña con doble factor (2FA)": "Ingresa tu correco electronico para recibir un link de recuperación,"}</h2>
        <Card>
          <Card.Body>
            { this.props.token?          
              <Grid.Row>         
                <Grid.Col>
                  <Form.Group label="Nuevo Password">
                    <Form.Input name="newPassword" type="password" autoComplete="new-password" value={this.state.newPassword} onChange={this.changeNewPassword} />
                    <div >{this.state.newPassword?password(this.state.newPassword):""}</div>
                  </Form.Group>
                </Grid.Col>          
                <Grid.Col>
                  <Form.Group label="Confirmar Password">
                    <Form.Input name="newPasswordC" type="password" autoComplete="new-password" value={this.state.newPasswordC} onChange={(e)=> this.setState({newPasswordC:e.target.value})} />
                  </Form.Group>
                  <div >{this.state.newPasswordC.length? this.state.newPasswordC !== this.state.newPassword? "Las contraseñas son diferentes":"":"" }</div>
                </Grid.Col>
                <Table.Col>
                      <Button target="_blank" size="sm" RootComponent="a" color="primary"
                      disabled= { this.habilitarBoton()}
                      onClick={() => this.crud_putPassword() }>
                      <span className="badge"><Icon link={true} name="refresh-ccw" />{this.passwordObj.newPasswordC === this.passwordObj.newPassword && this.passwordObj.newPassword.length   ? 'Actualizar Contraseña':'Actualizar contraseña' 
                      }</span>
                      </Button>                 
                </Table.Col>
              
              </Grid.Row>
            : null}
            { this.state.modo2fa && ! this.state.showQr?
              <div>
                <Grid.Row>
                  <Grid.Col>
                    <Form.Group label="Username">
                      <Form.Input name="username2fa" type="text" autoComplete="off" value={this.state.username2fa} onChange={(e)=> this.setState({ username2fa: e.target.value })} placeholder="Tu nombre de usuario" />
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col>
                    <Form.Group label="Código 2FA">
                      <Form.Input name="token2fa" type="password" autoComplete="off" value={this.state.token2fa} onChange={(e)=> this.setState({ token2fa: e.target.value })} placeholder="Código de tu app autenticadora" />
                    </Form.Group>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <Form.Group label="Nuevo Password">
                      <Form.Input name="newPassword" type="password" autoComplete="new-password" value={this.state.newPassword} onChange={this.changeNewPassword} />
                      <div>{this.state.newPassword? password(this.state.newPassword): ""}</div>
                    </Form.Group>
                  </Grid.Col>
                  <Grid.Col>
                    <Form.Group label="Confirmar Password">
                      <Form.Input name="newPasswordC" type="password" autoComplete="new-password" value={this.state.newPasswordC} onChange={(e)=> this.setState({newPasswordC:e.target.value})} />
                    </Form.Group>
                    <div>{this.state.newPasswordC.length? this.state.newPasswordC !== this.state.newPassword? "Las contraseñas son diferentes":"":"" }</div>
                  </Grid.Col>
                  <Table.Col>
                    <Button target="_blank" size="sm" RootComponent="a" color="primary"
                      disabled={ this.habilitarBoton() || !this.state.username2fa.length || !this.state.token2fa.length }
                      onClick={() => this.crud_putPassword2fa() }>
                      <span className="badge"><Icon link={true} name="refresh-ccw" /> Actualizar contraseña</span>
                    </Button>
                  </Table.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <Button size="sm" color="secondary" onClick={() => this.setState({ modo2fa: false, newPassword: '', newPasswordC: '', username2fa: '', token2fa: '' })}>
                      <span className="badge text-dark"><Icon link={true} name="arrow-left" /> Volver</span>
                    </Button>
                  </Grid.Col>
                </Grid.Row>
              </div>
            : null}
            {!this.state.modo2fa?
            <div>
              <Grid.Row>         
                <Grid.Col>
                  <Form.Input name="mail" type="mail"  value={this.state.correo} onChange={(e)=> this.setState({ correo: e.target.value })} placeholder="abc@dominio.ext" />
                  {this.state.correo &&!mail(this.state.correo)?<h5>No parece ser una cuenta de correo valida</h5>:null}
                </Grid.Col>
                <Table.Col>
                      <Button target="_blank" size="sm" RootComponent="a" color="primary" onClick={() => this.enviarCorreo() } disabled={ !mail(this.state.correo) || this.state.send} >
                      <span className="badge"><Icon link={true} name="send" />  </span>
                      </Button>                 
                </Table.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col>
                  <Button size="sm" color="secondary" className="mt-3" onClick={() => this.setState({ modo2fa: true })}>
                    <span className="badge text-dark"><Icon link={true} name="shield" /> Recuperar con 2FA</span>
                  </Button>
                </Grid.Col>
              </Grid.Row>
            </div>
            :null}
          </Card.Body>
        </Card>{console.log(this.state.qrImage)}
        { this.state.showQr && this.state.qrImage && this.state.qrImage.data?
          <Card>
            <Card.Header>{this.state.qrImage.message}</Card.Header>
            <Card.Body>
              <h5>Escanea el código en tu aplicación 2FA</h5>
              { !this.state.qrImage.data.mfaCode ?
                <p className="alert alert-danger">{"Ha ocurrido un error"}</p>
                : null
              }
              { this.state.qrImage.data.qrCode ?
                <p>
                  <img
                    src={this.state.qrImage.data.qrCode}
                    style={{cursor: "not-allowed", pointerEvents: "none"}} />
                  <br/>{this.state.qrImage.data.mfaCode
                }
                </p>
                : null
              }
              <Button size="sm" color="success" onClick={() => { window.location.href = "/login"; }}>
                <span className="badge">Listo</span>
              </Button>
            </Card.Body>
          </Card>
          : null
        }
        
      </div>
    );
  }

  habilitarBoton=()=> {
    if(!password(this.state.newPassword).length && this.state.newPassword === this.state.newPasswordC){
      return false;
    }else{
      return true;
    }
  }


}
export default RecuperarPassword;
